import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import request from 'meinian-package/src/utils/request'
import logo from 'image/logo_icon.png'
import './multiImgCard.less'
import { ossImg } from 'meinian-package/src/utils/image'
import InsCollMoreAction from './insCollMoreAction'
import CardInfo from './cardInfo'

export default (props) => {
  const {
    itemMinWidth = 275,
    maxHeight = 500,
    columnWidth,
    coverImgUrl,
    name,
    id,
    lastBlogList,
    ownerName,
    blogNum,
    topStatus,
    initWaterfall,
    userNum,
    isPro,
    hiddenSticky,
    isDataAnalysis,
    markerNum,
    loginUserInfo,
    cooperation,
    setData,
    fetchData,
    isQuickAccess,
    shareStatus,
    onResize,
  } = props
  const history = useNavigate()
  const [maskVisible, setMaskVisible] = useState(false)
  const firstRecentImg = coverImgUrl ? lastBlogList && lastBlogList[0]?.mainUrl : lastBlogList && lastBlogList[1]?.mainUrl
  const secondRecentImg = coverImgUrl ? lastBlogList && lastBlogList[1]?.mainUrl : lastBlogList && lastBlogList[2]?.mainUrl

  const jumpToDetail = () => {
    history(`/home/coll/detail/${id}?inspirationId=${id}&tab=${isDataAnalysis ? 4 : ''}`)
    request.track({ code: 6400003, type: `查看灵感集-${id}` })
  }
  const onSticky = async (_topStatus, e) => {
    e && e.stopPropagation()
    if (_topStatus) {
      await request.get('/ins/inspiration/remove-top', { params: { inspirationId: id } })
    } else {
      await request.get('/ins/inspiration/set-top', { params: { inspirationId: id } })
    }
    initWaterfall && initWaterfall()
  }

  const _onChange = (success, itemParams) => {
    if (success) {
      setData((data) => {
        const index = data.findIndex((item) => item.id === itemParams.id)
        if (index !== -1) {
          data[index] = { ...data[index], ...itemParams }
        }
        return [...data]
      })
      fetchData()
      onResize?.()
    }
  }
  const _onDelete = (itemParams) => {
    if (itemParams.id) {
      setData((data) => {
        const index = data.findIndex((item) => item.id === itemParams.id)
        data.splice(index, 1)
        return data
      })
      fetchData()
      onResize?.()
    }
  }
  return (
    <a
      className="meinian-waterfall-card-multi-img"
      onClick={(e) => {
        e.preventDefault()
        jumpToDetail()
      }}
      style={{
        width: columnWidth,
        height: 0.6 * columnWidth + 80,
        minWidth: itemMinWidth,
        minHeight: 0.6 * itemMinWidth + 80,
        maxHeight: maxHeight + 80,
      }}
    >
      <div
        className="multi-img-wrap"
        style={{ height: 0.6 * columnWidth }}
        onMouseEnter={() => setMaskVisible(true)}
        onMouseLeave={() => setMaskVisible(false)}
      >
        {coverImgUrl || (lastBlogList && lastBlogList[0]) ? (
          <img
            className="main-img"
            referrerPolicy="no-referrer"
            src={ossImg(coverImgUrl || (lastBlogList && lastBlogList.length ? lastBlogList[0].mainUrl : ''), 600, 600)}
          />
        ) : (
          <div className="main-img-empty">
            <img style={{ objectFit: 'cover' }} src={logo} />
          </div>
        )}
        <div className="recent-update-img">
          <div className="recent-img-1" style={{ maxHeight: (0.6 * columnWidth) / 2 }}>
            {firstRecentImg ? (
              <img
                referrerPolicy="no-referrer"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                src={ossImg(firstRecentImg, 600, 600)}
              />
            ) : (
              <img style={{ width: '34%' }} src={logo} />
            )}
          </div>
          <div className="recent-img-2" style={{ maxHeight: (0.6 * columnWidth) / 2 }}>
            {secondRecentImg ? (
              <img
                referrerPolicy="no-referrer"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                src={ossImg(secondRecentImg, 600, 600)}
              />
            ) : (
              <img style={{ width: '34%' }} src={logo} />
            )}
          </div>
        </div>
        <div className="multi-img-coll-mask" style={{ opacity: maskVisible ? 1 : 0 }}>
          <div className="user-wrap">
            {cooperation ? (
              <div className="info line-1" style={{ minWidth: 'fit-content' }}>
                {userNum ? <span style={{ marginRight: 8 }}>{userNum}人协作</span> : null}
                {markerNum ? <span>{markerNum}人审核</span> : null}
              </div>
            ) : (
              <div className="info line-1" style={{ minWidth: 'fit-content' }}>
                私密
              </div>
            )}
          </div>
          <div className="actions">
            {hiddenSticky ? null : (
              <div
                className="button"
                onClick={(e) => {
                  e.preventDefault()
                  onSticky(topStatus, e)
                  request.track({ code: 6400008, type: `置顶灵感集-${id}-${topStatus}` })
                }}
              >
                {topStatus ? '取消置顶' : '置顶'}
              </div>
            )}
            <div className="meinian-space" />
            <div onClick={(e) => e.stopPropagation()}>
              <InsCollMoreAction
                loginUserInfo={loginUserInfo}
                isQuickAccess={isQuickAccess}
                shareStatus={shareStatus}
                id={id}
                name={name}
                onDelete={_onDelete}
                onChange={_onChange}
              />
            </div>
          </div>
        </div>
      </div>
      <CardInfo isPro={isPro} name={name} ownerName={ownerName} blogNum={blogNum} />
    </a>
  )
}
